import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import swal from 'sweetalert';
import swal2 from 'sweetalert2';
import { connect } from 'react-redux';
import Async from 'react-select/async';
import { getPicklist } from '../Registration/actions';
import BeneficaryMember from './BeneficaryMember';
import Attachment from './Attachment';
import { updateApplication, getApplicationPersonList, getAllAttachment, saveAttachment, getApplicationBeneList } from './actions';
import { getBase64 } from '../../../utils/common';
import {
    getApplicationDetail,
    submitVerifyBene,
} from '../services';
import { getPostaCodeOptions } from '../actions/common';

const exceptionRoom = ['HDB 1 room', 'HDB 2 room', 'HDB 3 room', 'HDB 4 room', 'HDB 5 room','1 room','2 room','3 room','4 room','5 room']
//fe only blacklist room for flat type

class ApplicationDetail extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false,
            appDetail: {
                Application_Status__c: '',
            },
            appBeneList: [],
            appHouList: [],
            attachmentList: [],
            newAttachments: [],
            edit: false,
            attachmentLoading: false,
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onApprove = this.onApprove.bind(this);
        this.onReject = this.onReject.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onFormChanged = this.onFormChanged.bind(this);
        this.updateApplication = updateApplication.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onSaveUpload = this.onSaveUpload.bind(this);
        this.updateAppDetail = this.updateAppDetail.bind(this);
        this.updatePostcode = this.updatePostcode.bind(this);
        this.updateFlatType = this.updateFlatType.bind(this);
        this.getEditable = this.getEditable.bind(this);
        this.deleteApplication = this.deleteApplication.bind(this);
    }

    async componentWillMount() {// fetch app detail and list of bene & household members
        try {
            this.setState({ loading: true });
            const { match, user } = this.props;
            const appDetail = await getApplicationDetail(match.params.applicantionId, user.siteToken.hash, user.key);
            // function called on base of usertype
            const appBeneList = this.props.user.loggedInUser.Partner_Authority__c !== null ? await getApplicationPersonList(
                this.props.match.params.applicantionId, this.props.user.loggedInUser.AccountId,
                'Beneficiary', this.props.user.siteToken.hash, this.props.user.key,
            ) : await getApplicationBeneList(this.props.user.loggedInUser.AccountId, this.props.user.siteToken.hash, this.props.user.key);
            const houseHoldMember = await getApplicationPersonList(
                this.props.match.params.applicantionId, this.props.user.loggedInUser.AccountId,
                'Household Member', this.props.user.siteToken.hash, this.props.user.key,
            );
            const beneficaryIds = [];
            // const filteredAppBeneList = appBeneList.records.filter(x => x.Application_Status__c !== 'Deleted By Partner')
            if (appBeneList.records) appBeneList.records.map(beneList => beneficaryIds.push(beneList.Id));
            if (houseHoldMember.records) houseHoldMember.records.map(eachMember => beneficaryIds.push(eachMember.Id));
            const attachmentList = await getAllAttachment(beneficaryIds, this.props.user.siteToken.hash, this.props.user.key);
            this.setState({
                appDetail: appDetail.records[0] || null,
                appBeneList: appBeneList.records || [],
                appHouList: houseHoldMember.records || [],
                attachmentList: attachmentList.records || [],
                loading: false,
            });

            const editable = this.getEditable(appDetail.records[0].Application_Status__c);
            if(editable === 'true') this.setState({ edit: true });

        } catch (error) {
            console.log(error);
            swal({
                text: error.toString(),
                title: 'An Error Occured',
            });

            this.setState({ loading: false });
        }
    }

    onSubmit() {
        if (this.state.loading === true) return;
        const datas = [];
        this.state.appBeneList.map((Benitem) => {
            const data = {
                Id: Benitem.Id,
                Application_Status__c: Benitem.Application_Status__c == 'Rejected By Partner' ? Benitem.Application_Status__c : 'Submitted by Partner',
                No_of_Receipts_Approved__c: 0,
                Payout_Start__c: new Date(),
                Payout_End__c: new Date(),
            };
            datas.push(data);
        });
        this.setState({ loading: true });
        submitVerifyBene(
            datas,
            this.props.user.siteToken.hash,
        ).then(response => response.json())
            .then((res) => {
                if (res.status === 200) {
                    swal({
                        title: 'Application has been submitted',
                        text: 'This application has been submitted. Approver will process this application',
                    });
                    this.componentWillMount();
                } else {
                    swal({
                        text: res.message,
                        title: 'An error occured when submitting application',
                    });
                }
            }).catch(err => swal(err));
    }

    onApprove() {//update application status to approved
        const datas = [];
        this.state.appBeneList.map((Benitem) => {
            const data = {
                Id: Benitem.Id,
                Application_Status__c: Benitem.Application_Status__c == 'Rejected By Partner' ? Benitem.Application_Status__c : 'Approved by Partner',
            };
            datas.push(data);
        });
        submitVerifyBene(
            datas,
            this.props.user.siteToken.hash,
        ).then(response => response.json())
            .then((res) => {
                if (res.status === 200) {
                    window.location.reload();
                } else {
                    swal('Error!! Please Contact Administrator');
                }
            });
    }

    onReject() {//update application status to rejected
        const datas = [];
        this.state.appBeneList.map((Benitem) => {
            const data = {
                Id: Benitem.Id,
                Application_Status__c: 'Rejected By Partner',
            };
            datas.push(data);
        });
        submitVerifyBene(
            datas,
            this.props.user.siteToken.hash,
        ).then(response => response.json())
            .then((res) => {
                if (res.status === 200) {
                    this.componentWillMount();
                } else {
                    swal('Error!! Please Contact Administrator');
                }
            });
    }

    onBack() {
        this.props.history.push('/portal/applications');
    }

    onFormChanged(attributeName, value) {
        this.setState({
            appDetail: {
                ...this.state.appDetail,
                [attributeName]: value,
            },
        });
    }

    onUpload(event) {
        const { newAttachments } = this.state;
        const file = event.target.files[0];
        const fileName = file.name.replace(/ |-/g, '_');
        const attachment = {
            Name: fileName,
            Body: '',
            parentId: this.state.appDetail.Applicant__r.Id,
            ContentType: file.type,
        };
        getBase64(file).then((encodedFile) => {
            attachment.Body = encodedFile.split(',')[1];
            newAttachments.push(attachment);
            this.setState({ newAttachments });
        });
    }

    onRemove(event) {
        const attcIdx = Number(event.target.id.match(/\d+/)[0]);
        const { newAttachments } = this.state;
        newAttachments.splice(attcIdx, 1);
        this.setState({ newAttachments });
    }

    onSaveUpload() {
        const { attachmentLoading } = this.state;
        if (attachmentLoading) return;
        this.setState({ attachmentLoading: true });
        const siteToken = this.props.user.siteToken.hash;
        const attachedList = [];
        this.state.newAttachments.map((attachment) => {
            attachedList.push(saveAttachment(attachment, siteToken));
        });
        Promise.all(attachedList)
            .then((result) => {
                const beneficaryIds = [];
                this.state.appBeneList.map(beneList => beneficaryIds.push(beneList.Id));
                this.state.appHouList.map(eachMember => beneficaryIds.push(eachMember.Id));
                getAllAttachment(beneficaryIds, this.props.user.siteToken.hash, this.props.user.key).then((res) => {
                    this.setState({
                        attachmentList: res.records || [],
                        newAttachments: [],
                        attachmentLoading: false,
                    });
                });
            })
            .catch((err) => {
                this.setState({ attachmentLoading: false });
                swal({
                    icon: 'warning',
                    text: err.message,
                });
            });
    }

    updatePostcode(selectedPC) {
        const { value: postcode, STREETNAME: streetName, BLDGNO: block } = selectedPC;
        const { appDetail } = this.state;
        appDetail.Postal__c = postcode;
        appDetail.Street__c = streetName;
        appDetail.Block__c = block;
        this.setState({ appDetail });
    }

    updateFlatType(selectedFT) {
        const { value } = selectedFT;
        const { appDetail } = this.state;

        appDetail.Flat_Type__c = value;
        appDetail.Other_Flat_type__c = value !== 'Others' ? '' : appDetail.Other_Flat_type__c;
        this.setState({
            appDetail: {
                ...appDetail,
                Flat_Type__c: value,
                Other_Flat_type__c: value !== 'Others' ? '' : appDetail.Other_Flat_type__c,
            },
        }, this.forceUpdate);
    }

    updateAppDetail(e) {
        const { name, value } = e.target;
        const { appDetail } = this.state;
        appDetail[name] = value;
        this.setState({ appDetail });
    }

    getEditable(status) {
        if (status === 'Received') {
            const query = new URLSearchParams(this.props.location.search);
            return query.get('edit');
        }
        return null;
    }

    deleteApplication() {
        const status = 'Deleted by Partner';
    }

    render() {
        const { appDetail } = this.state;
        const { objectInfo } = this.props;

        const submitButton = type => (
            <button className={`btn btn-${type} btn-info`} onClick={this.updateApplication}>Update</button>
        );
        const partnerIsSchool = this.props.user.loggedInUser.Account.Partner_Type__c === 'School';

        return (
            <div id="applicationDetail" className="row">
                <div className="col-lg-9 col-sm-12 col-md-9">
                    <div className="card">
                        <div className="col-md-12" style={{ textAlign: 'center', marginBottom: 30 }}>
                            {this.props.user.loggedInUser.Partner_Authority__c === 'Approver' ? (
                                <div>
                                    <button className="btn btn-small btn-orange" onClick={this.onBack}>
                                        Back
                                    </button>
                                    {appDetail.Application_Status__c === 'Received' ? submitButton('small') : ''}
                                </div>
                            ) : (
                                <div className="btn-group">
                                    <button className="btn btn-default" onClick={this.onBack}>Back</button>
                                    {appDetail.Application_Status__c === 'Received' ? submitButton('fill') : ''}
                                </div>
                            )}
                        </div>
                        <div className="clearfix" />
                        <p style={{ textAlign: 'center' }}>
                            {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                        </p>
                        <h4>Application Detail</h4>
                        <hr />
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Application No.</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Name : ''}
                                    readOnly
                                />
                            </div>
                            <div className="form-group">
                                <label>Applicant Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Applicant_Name__c : ''}
                                    disabled={!this.state.edit}
                                    onChange={e => this.onFormChanged('Applicant_Name__c', e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Applicant ID Type</label>
                                <select
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Applicant_ID_Type__c : ''}
                                    disabled={!this.state.edit}
                                    onChange={e => this.onFormChanged('Applicant_ID_Type__c', e.target.value)}
                                >
                                    <option value="NRIC">NRIC</option>
                                    <option value="Passport">Passport</option>
                                    <option value="FIN">FIN</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Applicant ID Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Applicant_ID__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div>
                            <div className="form-group">
                                <label>Applicant Marital Status</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Applicant_Marital_Status__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div>
                            {/* <div className="form-group">
                                <label>Applicant Race</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Applicant_Race__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div> */}
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Date of Application</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Date_of_Application__c : ''}
                                    disabled
                                />
                            </div>
                            {/* <div className="form-group">
                                <label>Application Type</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Application_Type__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div> */}
                            <div className="form-group">
                                <label>Application Status</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Application_Status__c : ''}
                                    disabled
                                />
                            </div>
                            <div className="form-group">
                                <label>Source of Application</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Source_of_Application__c : ''}
                                    disabled
                                />
                            </div>
                            <div className="form-group">
                                <label>Flat Type</label>
                                <select
                                    name="Flat_Type__c"
                                    onChange={(e) => {
                                        this.setState({
                                            appDetail: {
                                                ...appDetail,
                                                Flat_Type__c: e.target.value,
                                            },
                                        });
                                    }}
                                    className="form-control select"
                                    value={appDetail.Flat_Type__c}
                                >
                                    <option value="" />
                                    {getPicklist('Flat_Type__c', objectInfo.Application__c, 'component', exceptionRoom)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Other Flat Type</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Other_Flat_type__c"
                                    onChange={this.updateAppDetail}
                                    value={appDetail ? appDetail.Other_Flat_type__c : ''}
                                    disabled={!(appDetail.Application_Status__c === 'Received' && appDetail.Flat_Type__c === 'Others')}
                                />
                            </div>
                            {/* <div className="form-group">
                                <label>Other Flat Type</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Other_Flat_type__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div> */}
                            <div className="row">
                                <div className="col-sm-2 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail ? appDetail.Applicant_PDPA__c : ''}
                                        readOnly={!this.state.edit}
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    Applicant PDPA
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-sm-2 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail ? appDetail.Fail_Flat_Type__c : ''}
                                        readOnly={!this.state.edit}
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    Fail flat type criteria
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-sm-2 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail ? appDetail.Fail_Per_Cap_Income__c : ''}
                                        readOnly
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    PCI is more than S$750/month
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail ? appDetail.Fail_Bene_Requirement__c : ''}
                                        readOnly={!this.state.edit}
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    Exceeds 24 months of assistance - Families with Complex Needs (FCNs)
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-sm-2 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail.Applicant__r ? appDetail.Applicant__r.Incomplete_Document__c : ''}
                                        // readOnly={!this.state.edit}
                                        onChange={(e) => {
                                            this.setState({
                                                appDetail: {
                                                    ...appDetail,
                                                    Applicant__r: {
                                                        ...appDetail.Applicant__r,
                                                        Incomplete_Document__c: e.target.checked
                                                    },
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    Incomplete Document 
                                </div>
                            </div> */}
                        </div>
                        <div className="clearfix" />
                        <h4>Address</h4>
                        <hr />
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Postal Code</label>
                                <Async
                                    name="Postal__c"
                                    value={{
                                        value: appDetail.Postal__c || '',
                                        label: appDetail.Postal__c || '',
                                    }}
                                    loadOptions={getPostaCodeOptions}
                                    onChange={this.updatePostcode}
                                    disabled={!(appDetail.Application_Status__c === 'Received')}
                                />
                            </div>
                            <div className="form-group">
                                <label>Street</label>
                                <input
                                    name="Street__c"
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Street__c : ''}
                                    onChange={this.updateAppDetail}
                                    disabled={!(appDetail.Application_Status__c === 'Received')}
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Block Number</label>
                                <input
                                    name="Block__c"
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Block__c : ''}
                                    onChange={this.updateAppDetail}
                                    disabled={!(appDetail.Application_Status__c === 'Received')}
                                />
                            </div>
                            <div className="form-group">
                                <label>Unit Number</label>
                                <input
                                    name="Unit_Number__c"
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Unit_Number__c : ''}
                                    onChange={this.updateAppDetail}
                                    disabled={!(appDetail.Application_Status__c === 'Received')}
                                />
                            </div>
                        </div>
                        <div className="x_title">
                            <div className="clearfix" />
                        </div>
                        <div className="clearfix" />
                        <h4>Status</h4>
                        <hr />
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Total Number of HouseHold Member</label>
                                <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    name={partnerIsSchool ? 'Ttl_no_of_Household_mbr_Manual_Entry__c' : 'Total_number_of_household_members__c'}
                                    onChange={this.updateAppDetail}
                                    value={appDetail ? (partnerIsSchool ? appDetail.Ttl_no_of_Household_mbr_Manual_Entry__c : appDetail.Total_number_of_household_members__c) : ''}
                                    disabled={!(appDetail.Application_Status__c === 'Received' && partnerIsSchool)}
                                />
                            </div>
                            {/* <div className="form-group">
                                <label>No of Dependent youth/children</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.No_of_dependent_youth_children__c : ''}
                                    disabled
                                />
                            </div> */}
                            <div className="form-group">
                                <label>No of Bene</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.No_of_Bene__c : ''}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Completed Bene</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Approved_Bene__c : ''}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="x_title">
                            <div className="clearfix" />
                        </div>

                        <h4>Income Details</h4>
                        <hr />
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Total Income Earners</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Total_income_earners__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div>
                            <div className="form-group">
                                <label>Other Source of Income</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Other_Source_of_Income__c : ''}
                                    disabled={!this.state.edit}
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Total Monthly Gross Income</label>
                                <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    name={partnerIsSchool ? 'Ttl_Mthly_Gross_Income_Manual_Entry__c' : 'Total_Monthly_Gross_Income__c'}
                                    onChange={this.updateAppDetail}
                                    value={appDetail ? (partnerIsSchool ? appDetail.Ttl_Mthly_Gross_Income_Manual_Entry__c : appDetail.Total_Monthly_Gross_Income__c) : ''}
                                    disabled={!(appDetail.Application_Status__c === 'Received' && partnerIsSchool)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Calculated Per Capita Income</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={appDetail ? appDetail.Calculated_per_capita_income__c : ''}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="x_title">
                            Delaration And Consent
                            <div className="clearfix" />
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-sm-3 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail ? appDetail.Declaration_Completed__c : ''}
                                        readOnly
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    &nbsp;Declaration Completed
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-sm-3 checkContainer">
                                    <input
                                        type="checkbox"
                                        checked={appDetail ? appDetail.Media_Coverage_consent__c : ''}
                                        readOnly
                                    />
                                </div>
                                <div className="col-sm-9 text-content">
                                    &nbsp;Media Coverage Consent
                                </div>
                            </div>
                        </div>
                        <div className="clearfix" />
                    </div>
                </div>
                <BeneficaryMember
                    beneficaryList={this.state.appBeneList}
                    houseHoldList={this.state.appHouList}
                    userType={this.props.user.loggedInUser.Partner_Authority__c}
                />
                <Attachment
                    attachmentList={this.state.attachmentList}
                    newAttachments={this.state.newAttachments}
                    onUpload={this.onUpload}
                    onRemove={this.onRemove}
                    onSaveUpload={this.onSaveUpload}
                    userType={this.props.user.loggedInUser.Partner_Authority__c}
                    token={this.props.user.siteToken.hash}
                    publicKey={this.props.user.key}
                    loading={this.state.attachmentLoading}
                />
            </div>
        );
    }
}

ApplicationDetail.propTypes = {
    user: PropTypes.object.isRequired,
    match: PropTypes.object,
    objectInfo: PropTypes.object.isRequired,
    location: PropTypes.object,
};

ApplicationDetail.defaultProps = {
    match: {},
    location: {},
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        getApplicationDetail,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    objectInfo: state.objectInfo,
    flatTypeList: state.objectInfo.Application__c.filter(obj => obj.name === 'Flat_Type__c').length ? state.objectInfo.Application__c.filter(obj => obj.name === 'Flat_Type__c')[0].picklistValues : [],
});


export default connect(mapStateToProps, mapDispatchToProps)(ApplicationDetail);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Application/ApplicationDetail2.js
// module id = 982
// module chunks = 0